import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AlertSection from '../alert-section/alert-section.component'

const LocationAlert = ({ homeLocations }) => {
  const { t } = useTranslation(['checkIn'])

  return (
    <AlertSection
      type="location"
      title={t('checkIn:homeLocation', { count: homeLocations.length })}
      description={homeLocations.join(', ')}
    />
  )
}

LocationAlert.propTypes = {
  homeLocations: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default LocationAlert
